module.exports = {
  messages: {
    CN: {
      "arrivalNotice.productInformation": "商品信息",
      "arrivalNotice.productInformationPlaceholder": "请输入商品名称/编号",
      "arrivalNotice.customerQuantity": "客户数量",
      "arrivalNotice.massNotification": "批量通知",
      "arrivalNotice.massNotificationType": "批量通知类型",
      "arrivalNotice.emailNotice": "邮件通知",
      "arrivalNotice.WeChatOfficialAccountNotice": "公众号通知",
      "arrivalNotice.massNotificationErr": "请选择商品！",
      "arrivalNotice.sendsure": "确定要进行发送通知吗？",
      "arrivalNotice.sendsuccess": "发送成功",
      arrivalNotice: {
        noticeTitle: '通知名称',
        sellerName: '担当者',
        productNum: '商品数量',
        customerNum: '得意先数量',
        updateTime: '更新时间',
        action: '操作',
        notice: '通知',
        selectDyx: '勾选得意先',
        selectProduct: '选择商品',
        placeNoticeName: '请输入通知名称',
        placeSeller: '请选择担当者',
        settingProduct: '配置商品',
        productAdd: '添加商品',
        noticeObject: '通知对象',
        moreNotice: '批量通知',
        noticeSuccess: '通知成功',
        productTip: '请添加商品',
        customerTip: '请添加通知对象',
        sameProductTip: '该商品已存在, 请重新选择',
        addsuccess: '添加成功'
      }
    },
    JP: {
      "arrivalNotice.productInformation": "商品信息",
      "arrivalNotice.productInformationPlaceholder": "请输入商品名称/编号",
      "arrivalNotice.customerQuantity": "客户数量",
      "arrivalNotice.massNotification": "批量通知",
      "arrivalNotice.massNotificationType": "批量通知类型",
      "arrivalNotice.emailNotice": "邮件通知",
      "arrivalNotice.WeChatOfficialAccountNotice": "公众号通知",
      "arrivalNotice.massNotificationErr": "请选择商品！",
      "arrivalNotice.sendsure": "确定要进行发送通知吗？",
      "arrivalNotice.sendsuccess": "发送成功",
      arrivalNotice: {
        noticeTitle: '通知名',
        sellerName: '担当者',
        productNum: '商品数量',
        customerNum: '得意先数量',
        updateTime: '更新時間',
        action: '操作',
        notice: '通知',
        selectDyx: '得意先を選択',
        selectProduct: '商品を選択',
        placeNoticeName: '通知名を入力してください',
        placeSeller: '担当者を選択してください',
        settingProduct: '商品指定',
        productAdd: '商品を追加',
        noticeObject: '通知対象',
        moreNotice: '一括通知',
        noticeSuccess: '通知成功',
        productTip: '商品を追加してください',
        customerTip: '通知対象を追加してください',
        sameProductTip: 'この商品はすでに存在します。再度選択してください',
        addsuccess: '追加しました',
        dyxInfo: '得意先情報',
        dyxStatus: '得意先状態',
        busFormat: '業態',
        seller: '担当者',
        noticeType: '通知方法',
        noticeTime: '通知時間'
      }
    }
  }
};